import { configureStore } from "@reduxjs/toolkit";
import groupsDataReducer from './feature/groupsDataSlice'
import vCardDataReducer from "./feature/userDataSlice";
import rosterDataReducer from "./feature/rosterDataSlice"
import recentChatDataReducer from "./feature/recentChatDataSlice"
import recentChatItemsReducer from "./feature/recentChatItemsSlice"
import unreadCountDataReducer from "./feature/unreadCountSlice"
import appOnlineStatusReducer from "./feature/appOnlineSlice"
import activeChatDataReducer from "./feature/activeChatDataSlice"
import chatConversationHistoryReducer from "./feature/chatConversationHistorySlice"
import envDaraReducer from "./feature/envDataSlice"
import singleChatSelectedMediaSlice from "./feature/singleChatSelectedMediaSlice";
import groupsMemberParticipantsListReducer from "./feature/groupsMemberParticipantsListSlice"
import groupMembersDataReducer from "./feature/groupMembersDataSlice"
import typingStatusReducer from "./feature/typingStatusSlice"
import connectionStatusReducer from "./feature/connectionStatusSlice"
import presenseDataReducer from "./feature/presenceDataSlice"
import themeDataReducer from "./feature/themeDataSlice"
import dynamicIconReducer from "./feature/dynamicIconDataSlice"
import offlinePendingReducer from "./feature/offlinePendingSlice"
import pendingMediaReducer from "./feature/pendingMediaSlice"
import updateMediaUploadDataReducer from "./feature/updateMediaUploadDataSlice";
import featureFlagListReducer from "./feature/addFeatureDataSlice" 
import replyMessageDataReducer from "./feature/replyMessageDataSlice";
import forwardMessageDataReducer from "./feature/forwardMessageDataSlice";
import recentChatStatusReducer from "./feature/recentChatStatusSlice";
import messageInfoDataReducer from "./feature/messageInfoDataSlice";
import callConnectionDateReducer from "./feature/callConnectionDateSlice";
import showConfrenceDataReducer from "./feature/showConfrenceDataSlice";
import popUpDataReducer  from "./feature/popUpDataSlice";
import callConversionReducer  from "./feature/callConversionDataSlice";
import calllogsDataReducer  from "./feature/calllogsDataSlice";
import modalPopUpReducer from "./feature/modelPopUpDataSlice";
import callDurationTimestampReducer  from "./feature/callDurationDataSlice";
import pinUserDataSliceReducer from "./feature/pinUserDataSlice";
import browserTabDataReducer from "./feature/browserDataSlice";
import browserNotifyDataReducer from "./feature/browserNotifySlice";
import customThemeReducer from "./feature/customThemeDataSlice"
import messageDataReducer from "./feature/messageDataSlice";
import mirrorflyInitialReducer from "./feature/mirrorflyInitialDataSlice";
import chatSeenPendingMsgReducer from "./feature/chatSeenPendingMsgSlice";
import addCustomCallReducer from "./feature/addCustomCallSlice";
import translateLanguageReducer from "./feature/translateLanguageDataSlice";
import webLocalStorageSettingReducer from "./feature/webLocalStorageSettingDataSlice";
import blockedContactReducer from "./feature/blockContactSlice";
import adminBlockUserReducer from "./feature/adminBlockUserSlice";
import contactsWhoBlockedMeReducer from "./feature/contactsWhoBlockedMeSlice";
import callIntermediateScreenReducer from "./feature/callIntermediateScreenSlice";

export const store = configureStore({
    reducer:{
        envData:envDaraReducer,
        groupsData:groupsDataReducer,
        vCardData:vCardDataReducer,
        rosterData : rosterDataReducer,
        messageData: messageDataReducer,
        recentChatData:recentChatDataReducer,
        recentChatItems: recentChatItemsReducer,
        chatSeenPendingMsgData:chatSeenPendingMsgReducer,
        unreadCountData:unreadCountDataReducer,
        appOnlineStatus:appOnlineStatusReducer,
        activeChatData :activeChatDataReducer,
        chatConversationHistory:chatConversationHistoryReducer,
        groupsMemberParticipantsListData : groupsMemberParticipantsListReducer,
        groupMembersData:groupMembersDataReducer,
        typingData:typingStatusReducer,
        presenseData:presenseDataReducer,
        dynamicIcon:dynamicIconReducer,
        connStatus:connectionStatusReducer,
        offlinePendingStatus:offlinePendingReducer,
        themeData:themeDataReducer,
        pendingMedia:pendingMediaReducer,
        singleChatSelectedMediaData:singleChatSelectedMediaSlice,
        mediaUploadData:updateMediaUploadDataReducer,
        featureFlagList:featureFlagListReducer,
        replyMessageData:replyMessageDataReducer,
        selectedMessageData:forwardMessageDataReducer,
        recentChatStatus: recentChatStatusReducer,
        messageInfoData: messageInfoDataReducer,
        callConnectionDate:callConnectionDateReducer,
        showConfrenceData:showConfrenceDataReducer,
        popUpData:popUpDataReducer,
        callConversionData:callConversionReducer,
        callLogData:calllogsDataReducer,
        modalPopUpData:modalPopUpReducer,
        callDurationTimestamp:callDurationTimestampReducer,
        pinUserData:pinUserDataSliceReducer,
        browserTab:browserTabDataReducer,
        browserNotify:browserNotifyDataReducer,
        customTheme:customThemeReducer,
        mirrorflyInitial:mirrorflyInitialReducer,
        addCustomCall:addCustomCallReducer,
        translateLanguage:translateLanguageReducer,
        webLocalStorageSetting:webLocalStorageSettingReducer,
        blockedContact:blockedContactReducer,
        adminBlockUser:adminBlockUserReducer,
        contactsWhoBlockedMe:contactsWhoBlockedMeReducer,
        callIntermediateScreen:callIntermediateScreenReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
})